import { SelectField, SelectFieldProps } from 'components/form'
import React, { useCallback, useMemo } from 'react'

type RecordStringSelectFieldProps<T extends string> = Omit<
  SelectFieldProps<T>,
  'items' | 'itemToString' | 'itemIsEqual'
> & {
  record: Record<T, string>
  subset?: T[] | false
}

const itemIsEqual = (a: string | null | undefined, b: string | null | undefined) => a === b

export function RecordStringSelectField<T extends string>(props: RecordStringSelectFieldProps<T>) {
  const { record, subset, ...rest } = props

  const items = useMemo(() => subset || (Object.keys(record) as T[]), [subset, record])

  const itemToString = useCallback(
    (value: T | null | undefined) => {
      if (value === null || value === undefined) return ''
      return record[value] ?? String(value)
    },
    [record]
  )

  return <SelectField<T> items={items} itemToString={itemToString} itemIsEqual={itemIsEqual} {...rest} />
}
